import { emailTemplateApi } from '@/api/emailTemplates'

const state = {
    templates: []
}

const mutations = {
    SET_TEMPLATES(state, templates) {
        state.templates = templates
    },
    ADD_TEMPLATE(state, template) {
        state.templates.push(template)
    },
    UPDATE_TEMPLATE(state, updatedTemplate) {
        const index = state.templates.findIndex(t => t.id === updatedTemplate.id)
        if (index !== -1) {
            state.templates.splice(index, 1, updatedTemplate)
        }
    },
    DELETE_TEMPLATE(state, id) {
        state.templates = state.templates.filter(t => t.id !== id)
    }
}

const actions = {
    async fetchTemplates({ commit }) {
        try {
            const templates = await emailTemplateApi.getAll()
            commit('SET_TEMPLATES', templates)
        } catch (error) {
            console.error('Error fetching email templates:', error)
        }
    },
    async addTemplate({ commit }, template) {
        try {
            const newTemplate = await emailTemplateApi.create(template)
            commit('ADD_TEMPLATE', newTemplate)
        } catch (error) {
            console.error('Error adding email template:', error)
        }
    },
    async updateTemplate({ commit }, template) {
        try {
            const updatedTemplate = await emailTemplateApi.update(template.id, template)
            commit('UPDATE_TEMPLATE', updatedTemplate)
        } catch (error) {
            console.error('Error updating email template:', error)
        }
    },
    async deleteTemplate({ commit }, id) {
        try {
            await emailTemplateApi.delete(id)
            commit('DELETE_TEMPLATE', id)
        } catch (error) {
            console.error('Error deleting email template:', error)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

